import { Utils } from 'src/app/pages/core/utils/Utils';
import { CryptoService } from './../../../../abstraction/crypto.service';
import {
  COIN_FULL_NAME,
  ICoinInfo,
  ICryptoCoin,
  CURRENCY_FILTER,
  COIN_TICKER,
} from './../../../../models/Crypto';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CoinInfo } from '../../../../utils/cryptoCoinInfo';

@Component({
  selector: 'app-crypto-search-bar',
  templateUrl: './crypto-search-bar.component.html',
  styleUrls: ['./crypto-search-bar.component.scss'],
})
export class CryptoSearchBarComponent implements OnInit {
  @Input() currency: CURRENCY_FILTER = null;
  @Output() searchChange = new EventEmitter<ICryptoCoin[][]>();
  cryptos: ICryptoCoin[][] = [];
  searchValue: FormControl = new FormControl('', []);

  constructor(public cryptoService: CryptoService) {}

  ngOnInit(): void {
    this.cryptoService.stableCryptos.subscribe((stableCoins) => {
      this.cryptos[0] = stableCoins;
    });
    this.cryptoService.volatilCryptos.subscribe((volatilCoins) => {
      this.cryptos[1] = volatilCoins;
    });
  }

  search() {
    let searchResults: ICryptoCoin[][] = [];
    let searchValue: string = this.searchValue.value;

    if (searchValue.length > 0) {
      searchValue = searchValue.toLowerCase();
      this.cryptos.forEach((cryptoList) => {
        searchResults.push(
          cryptoList.filter(
            (crypto) =>
              crypto.active &&
              (crypto.currency === this.currency || !this.currency) &&
              this.searchHasMatch(crypto.ticker, searchValue),
          ),
        );
      });
    } else {
      searchResults = this.cryptos;
    }
    this.searchChange.emit(searchResults);
  }

  private searchHasMatch(ticker: string, searchValue: string): boolean {
    return (
      ticker.toLowerCase().includes(searchValue) ||
      this.searchInFullName(ticker, searchValue) ||
      this.searchInTags(ticker, searchValue)
    );
  }

  private searchInFullName(ticker: string, searchValue: string): boolean {
    const coinFullName: string = COIN_FULL_NAME[ticker];
    return coinFullName && coinFullName.toLowerCase().includes(searchValue);
  }

  private searchInTags(ticker: string, searchValue: string): boolean {
    const coinInfo: ICoinInfo = CoinInfo[ticker];
    return (
      coinInfo &&
      coinInfo.tags.some((tag: string) =>
        Utils.replaceAccents(tag).toLowerCase().includes(Utils.replaceAccents(searchValue)),
      )
    );
  }
}
